let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2Sp61")).then(() => parcelRequire('7zEKu'));